module.exports = __webpack_public_path__ + "indicator.png?bed97c35ba31adcf1ca09fdcfae8fd0f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/indicator.png
// module id = 71
// module chunks = 0